import React from 'react'
import Paper from '@material-ui/core/Paper'
import Button from '@material-ui/core/Button'
import CircularProgress from '@material-ui/core/CircularProgress'
import { withStyles } from '@material-ui/core/styles'
import LockTabTable from './LockTabTable'

const styles = theme => ({
    root: {
        flexGrow: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
    },
    paper: {
        padding: theme.spacing.unit * 2,
        textAlign: 'center',
        color: theme.palette.text.secondary
    },
    container: {
        display: 'flex',
        flexWrap: 'wrap'
    },
    formControl: {
        margin: theme.spacing.unit,
        width: 250
    },
    button: {
        margin: theme.spacing.unit
    },
    progress: {
        margin: theme.spacing.unit * 2
    }
})

class LockTab extends React.Component {
    handleClick = () => {
        this.props.handleClickSearch()
    }

    render() {
        const { fetching, locks, classes, privateRooms, commonArea, easymsCategories, currentOrganization } = this.props

        return (
            <div>
                <Paper className={classes.paper}>
                    <Button variant="raised" color="primary" className={classes.button} onClick={this.handleClick}>
                        Получить замки
                    </Button>
                </Paper>
                <div style={{ marginTop: '24px' }}>
                    {fetching ? (
                        <CircularProgress className={classes.progress} />
                    ) : (
                        <LockTabTable
                            currentOrganization={currentOrganization}
                            privateRooms={privateRooms}
                            commonArea={commonArea}
                            easymsCategories={easymsCategories}
                            locks={locks}
                            classes={classes}
                        />
                    )}
                </div>
            </div>
        )
    }
}

export default withStyles(styles)(LockTab)



// WEBPACK FOOTER //
// ./src/components/ChannelTabs/OmnitecTab/MappingTabs/LockTab/LockTab.js